
export const reportBasePath = '/reports';
export const reportDashboardPath = `${reportBasePath}/dashboard`;
export const reportPrintPath = `${reportBasePath}/printreport`;
export const getReportKey = 'getReportKey';
